import type { FC } from 'react'

import LogoCarouselBase, * as LogoCarousel from '@segment/matcha/recipes/LogoCarousel'
import type { LogoTrackProps } from '@segment/matcha/recipes/LogoCarousel/LogoTrack'

export interface LogoCarouselTemplateProps {
  heading?: string
  logos: LogoTrackProps[`icons`]
}

const LogoCarouselTemplate: FC<LogoCarouselTemplateProps> = ({
  heading = `Join the 25,000+ companies using the Segment platform`,
  logos: externalLogos,
  ...rest
}) => {
  return (
    <LogoCarouselBase {...rest}>
      <LogoCarousel.Heading>{heading}</LogoCarousel.Heading>
      <LogoCarousel.LogoTrack icons={externalLogos} />
    </LogoCarouselBase>
  )
}

export default LogoCarouselTemplate
